<script>
  import { onMount } from 'svelte';
  import { navigate } from 'svelte-routing';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { authFetch } from '../authService'; // <-- IMPORT THIS
  
  export let id; // From router

  let productName = '';
  let storeName = '';
  let originalPrice = '';
  let discountPrice = '';
  let description = '';
  let discountPercentage = '';
  let barcode = '';

  let currentUser = null;
  let error = '';
  let isSubmitting = false;

  authStore.subscribe(value => {
    currentUser = value.user;
  });

  onMount(async () => {
    try {
      const response = await fetch(getApiUrl(`/products/${id}`));
      if (!response.ok) throw new Error('Product not found.');
      const data = await response.json();
      productName = data.productName || '';
      storeName = data.storeName || '';
      originalPrice = data.originalPrice || '';
      discountPrice = data.discountPrice || '';
      description = data.description || '';
      discountPercentage = data.discountPercentage || '';
      barcode = data.barcode || '';
    } catch(e) {
      error = e.message;
    }
  });

  function calculateDiscount() {
    const orig = parseFloat(originalPrice);
    const disc = parseFloat(discountPrice);
    if (orig > 0 && disc >= 0 && orig > disc) {
      discountPercentage = (((orig - disc) / orig) * 100).toFixed(2);
    } else if (description.toLowerCase().includes('buy 1 get 1 free')) {
      discountPercentage = 50.00.toFixed(2);
    } else if (description.toLowerCase().includes('buy 2 get 1 free')) {
      discountPercentage = (1/3 * 100).toFixed(2);
    } else {
      discountPercentage = '';
    }
  }
  
  $: if (originalPrice || discountPrice || description) {
    calculateDiscount();
  }

  async function handleSubmit() {
    isSubmitting = true;
    error = '';
    
    const payload = {
      _id: id,
      productName,
      storeName,
      originalPrice: originalPrice ? parseFloat(originalPrice) : null,
      discountPrice: discountPrice ? parseFloat(discountPrice) : null,
      description,
      discountPercentage: discountPercentage ? parseFloat(discountPercentage) : null,
      barcode,
      uploadedByUserId: currentUser?.idTokenClaims?.oid,
    };

    try {
      const response = await authFetch(getApiUrl(`/products/${id}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('Failed to update product discount.');
      navigate('/products/search'); // Go to search page after saving
    } catch (e) {
      error = e.message;
    } finally {
      isSubmitting = false;
    }
  }

  // Back Function ---
  function goBack() {
      window.history.back();
  }
</script>

<div class="form-container">
  <!-- NEW: Back Button -->
  <button type="button" class="back-btn" on:click={goBack}>← Back</button>
  
  <h2>Edit Product Discount</h2>
  <form on:submit|preventDefault={handleSubmit}>
    <fieldset>
      <div class="form-group">
        <label for="store-name">Store Name (Required)</label>
        <input type="text" id="store-name" bind:value={storeName} required />
      </div>
      <div class="form-group">
        <label for="product-name">Product Name (Required)</label>
        <input type="text" id="product-name" bind:value={productName} required />
      </div>
      <div class="form-group">
        <label for="barcode">Barcode (UPC/EAN)</label>
        <input type="text" id="barcode" bind:value={barcode} />
      </div>
      <div class="form-group">
        <label for="orig-price">Original Price ($)</label>
        <input type="number" step="0.01" id="orig-price" bind:value={originalPrice} />
      </div>
      <div class="form-group">
        <label for="disc-price">Discount Price ($)</label>
        <input type="number" step="0.01" id="disc-price" bind:value={discountPrice} />
      </div>
      <div class="form-group">
        <label for="description">Promotion Description</label>
        <input type="text" id="description" bind:value={description} placeholder="e.g., Buy 1 Get 1 Free" />
      </div>
      <div class="form-group">
        <label for="disc-percent">Discount Percentage (%)</label>
        <input type="number" step="0.01" id="disc-percent" bind:value={discountPercentage} placeholder="Calculated automatically" />
      </div>
    </fieldset>

    <button type="submit" disabled={isSubmitting}>
      {#if isSubmitting}Saving...{:else}Save Changes{/if}
    </button>
    {#if error} <p class="error">{error}</p> {/if}
  </form>
</div>

<style>
  .back-btn {
      background: none;
      border: none;
      color: #6c757d;
      font-size: 1rem;
      cursor: pointer;
      padding: 0;
      margin-bottom: 1rem;
      font-weight: 500;
  }
  .back-btn:hover {
      color: #007bff;
      text-decoration: underline;
  }
  
  .form-container { max-width: 700px; margin: 2rem auto; }
  fieldset { border: 1px solid #ddd; border-radius: 8px; padding: 1.5rem; margin-bottom: 1rem; }
  .form-group { margin-bottom: 1rem; }
  label { display: block; margin-bottom: 0.5rem; font-weight: 500; }
  input { width: 100%; padding: 0.75rem; border: 1px solid #ccc; border-radius: 4px; font-size: 1rem; box-sizing: border-box; }
  button { padding: 0.75rem; background-color: #007bff; color: white; border: none; border-radius: 4px; font-size: 1.1rem; cursor: pointer; }
  button:disabled { background-color: #aaa; }
  .error { color: red; text-align: center; }
</style>